// @todo BUT WHY?
// Set mouse/touch classes
const $ = jQuery;
const $html = $('html');

$html.addClass('mouse-device');

window.addEventListener(
  'touchstart',
  function onFirstTouch() {
    $html.removeClass('mouse-device').addClass('touch-device');
    window.removeEventListener('touchstart', onFirstTouch, false);
  },
  false,
);
